exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".uib-time input{width:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/angular-ui-bootstrap/src/timePicker/timepicker.css
// module id = 1520
// module chunks = 1